import React from "react";
import { X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "../components/ui/dialog";
import { useI18n } from "../i18n";

export default function PhaseArticle({ phase, children }) {
  const { t } = useI18n();
  const article = phase.article;
  if (!article) return children;

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        data-testid={`phase-article-${phase.key}`}
        className="w-[calc(100vw-1.5rem)] max-w-md max-h-[88dvh] overflow-y-auto rounded-3xl bg-bone border-border p-0 gap-0"
      >
        <div
          className="p-6 pr-12 rounded-t-3xl min-w-0"
          style={{ backgroundColor: phase.color, color: phase.textColor }}
        >
          <div className="text-[11px] tracking-[0.25em] uppercase font-bold opacity-80">
            {phase.label} · {article.readTime}
          </div>
          <DialogTitle className="font-serif text-3xl leading-tight mt-1.5">
            {article.title}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t("articleAbout", { label: phase.label })}
          </DialogDescription>
        </div>

        <DialogClose className="absolute right-4 top-4 h-8 w-8 grid place-items-center rounded-full bg-black/15 hover:bg-black/25 transition-colors">
          <X className="h-4 w-4" style={{ color: phase.textColor }} />
          <span className="sr-only">Close</span>
        </DialogClose>

        <div className="p-6 space-y-4 min-w-0">
          {article.blocks.map((b) => (
            <div key={b.h || b.p.slice(0, 40)} className="space-y-1.5">
              {b.h && (
                <h4 className="font-serif text-xl leading-tight" style={{ color: phase.color }}>
                  {b.h}
                </h4>
              )}
              <p className="text-sm leading-relaxed text-foreground/85">{b.p}</p>
            </div>
          ))}
          {article.references && article.references.length > 0 && (
            <div className="pt-2 border-t border-border">
              <div className="text-[11px] tracking-[0.15em] uppercase font-bold text-muted-foreground mb-2">
                {t("references")}
              </div>
              <ul className="space-y-1.5">
                {article.references.map((r) => (
                  <li key={r.url} className="text-[11px] leading-snug">
                    <a
                      href={r.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-foreground/70 underline decoration-dotted underline-offset-2 hover:text-foreground break-words"
                    >
                      {r.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <p className="text-[11px] text-muted-foreground pt-2 border-t border-border leading-relaxed">
            {t("disclaimerPhase")}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
